<nav class="navbar navbar-expand-md navbar-dark bg-primary">
    <pace-core-side-menu></pace-core-side-menu>
    <a class="navbar-brand pb-0" href="#" translate="HEADER_TITLE"></a>
    <button
        class="navbar-toggler mt-2 fs-4"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarMenu"
        aria-controls="navbarMenu"
        aria-expanded="false"
        aria-label="NAV_ITEM_BUTTON | translate"
        (click)="toggleSideMenu()"
    >
        <fa-icon [icon]="faBars" size="md"></fa-icon>
    </button>
    <div
        class="navbar-collapse justify-content-start row slide-right"
        [ngClass]="{ show: isSideMenuOpen, close: !isSideMenuOpen }"
        id="navbarMenu"
    >
        <div class="col-9">
            <div class="navbar-nav row mt-5 mt-md-0">
                <div class="nav-item col-12 col-md-2 mt-md-1 ms-md-1 p-md-0">
                    <a
                        class="nav-link"
                        routerLink="protocol-provisioning"
                        routerLinkActive="active"
                        translate="NAV_ITEM_PROTOCOL"
                        (click)="isSideMenuOpen = false"
                    ></a>
                </div>
                <div class="nav-item col-12 col-md-2 mt-md-1 p-md-0">
                    <a
                        class="nav-link"
                        (click)="openForms()"
                        [ngClass]="
                            isFormsListPage ? 'active' : isDocBoxPage || isFormDetailsPage ? 'clickable-link' : ''
                        "
                        translate="NAV_ITEM_FORMS_LIST"
                    ></a>
                </div>
                <div class="nav-item col-12 col-md-2 mt-md-1 p-md-0">
                    <a
                        class="nav-link"
                        [ngClass]="isFormDetailsPage ? 'active' : ''"
                        translate="NAV_ITEM_FORM_DETAILS"
                        (click)="isSideMenuOpen = false"
                    ></a>
                </div>
                <div class="nav-item col-12 col-md-2 mt-md-1 p-md-0" [hidden]="!displayDocBox">
                    <a
                        class="nav-link"
                        (click)="openDocBox()"
                        [ngClass]="
                            isDocBoxPage ? 'active' : isFormsListPage || isFormDetailsPage ? 'clickable-link' : ''
                        "
                        translate="NAV_ITEM_DOCBOX"
                    ></a>
                </div>
            </div>
        </div>
        <span class="navbar-text text-end col-12 col-md-3">{{ appVersion }}</span>
    </div>
</nav>
